<template>
  <div>
    <Main ref="mian" :tableData="tableData" :loading="loading" />
  </div>
</template>
<script>
import BaseTable from "@/mixins/base-table"
import Main from "./mian.vue"
export default {
  mixins: [BaseTable],
  components: { Main },
  props: {
    planCode: String,
    detailCode: String,
  },
  data() {
    return {
      loading: false,
      usePage: true,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.detailCode && !this.planCode) return
      this.loading = true
      this.$api
        .mrpMaterialPlanScheduleListApi({
          mrpMaterialPlanDetailCode: this.detailCode,
          mrpMaterialPlanCode: this.planCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
